export default "__VITE_ASSET__E$pwLRAb__"